// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/jquery.event.move.js"; import "./autoload/jquery.twentytwenty.js"; import "./autoload/ocd-plugins.js"; import "./autoload/slick.min.js";

import "./autoload/jquery.event.move.js";
import "./autoload/jquery.twentytwenty.js";
import "./autoload/slick.min.js";
import "./autoload/ocd-plugins.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
//import aboutUs from './routes/about';
import single from './routes/casestudies';
import archive from './routes/archive';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  //aboutUs,
  single,
  archive,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js